import React, { useEffect, useRef } from "react";
import "./footer.css";
import leftTop from "../assets/group1.png";
import leftPaper from "../assets/elleil.png";
import leftSinger from "../assets/ummkulthum5.png";
import rightFrame from "../assets/frame.png";
import rightPaper from "../assets/ngomo.png";
import rightBottom from "../assets/lastpic.png";

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        footerRef.current.classList.add("show");
      }
    }, { threshold: 0.3 });

    observer.observe(footerRef.current);
  }, []);

  return (
    <footer ref={footerRef} className="footer">

      <img src={leftTop} className="footer-left-top" alt="old photo" />
      <img src={leftPaper} className="footer-left-paper" alt="paper" />
      <img src={leftSinger} className="footer-left-singer" alt="Umm Kulthum" />

      <div className="footer-center">
        <h2>Music is the language of the soul</h2>

        <div className="footer-line">
          <div className="line"></div>
          <span>Umm Kulthum</span>
          <div className="line"></div>
        </div>
      </div>

      <img src={rightFrame} className="footer-right-frame" alt="frame" />
      <img src={rightPaper} className="footer-right-paper" alt="paper" />
      <img src={rightBottom} className="footer-right-bottom" alt="cassette" />

    </footer>
  );
};

export default Footer;